import React from 'react';

type FilterFieldBaseProps = {
  label: string;
  headerActions?: React.ReactNode;
  showTypeaheadHint?: boolean;
  isFetching?: boolean;
  guidedText?: string;
  showGuidedText?: boolean;
  children: React.ReactNode;
};

export function FilterFieldBase({
  label,
  headerActions,
  showTypeaheadHint,
  isFetching,
  guidedText,
  showGuidedText,
  children,
}: FilterFieldBaseProps) {
  return (
    <div>
      <div className="mb-2 flex items-center justify-between gap-2">
        <label className="text-xs font-bold uppercase text-gray-500">{label}</label>
        {headerActions}
      </div>
      {children}
      {showTypeaheadHint ? (
        <p className="mt-2 text-xs text-slate">Escribe mas caracteres para ver mas resultados.</p>
      ) : null}
      {isFetching ? <p className="mt-2 text-xs text-slate">Buscando...</p> : null}
      {showGuidedText && guidedText ? (
        <p className="mt-2 text-xs text-slate">{guidedText}</p>
      ) : null}
    </div>
  );
}

export type { FilterFieldBaseProps };
